<template>
  <div class="global-wrapper">
    <a-header-wrapper />

    <div class="page-wrap">
      <a-layout-content-container>
        <nuxt ref="nuxt" />

        <a-footer />
      </a-layout-content-container>
    </div>

    <client-only>
      <a-error-handler-notifier v-if="isDevelopment" />
    </client-only>

    <gtm-no-script />

    <a-auth-modal-lazy-load />
    <a-error-modal-lazy-load />
    <winners-highlights-modal-lazy-load />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import ALayoutContentContainer from '@/components/_layout/ALayoutContentContainer'
import AErrorHandlerNotifier from 'shared/AErrorHandlerNotifier'
import GtmNoScript from 'shared/GtmNoScript/index.vue'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import AAuthModalLazyLoad from '@/components/_layout/modals/AuthModal/lazy.vue'
import AErrorModalLazyLoad from '~/components/_layout/modals/ErrorModal/lazy.vue'
import WinnersHighlightsModalLazyLoad from 'sections/_winners/WinnersHighlightsSection/WinnersHighlightsModal/lazy.vue'
import AHeaderWrapper from '@/components/_layout/headers/AHeaderWrapper/index.vue'
import { CMP_STATE } from '../utils/enums/cmp'

export default {
  name: 'DefaultLayout',
  components: {
    AHeaderWrapper,
    AErrorModalLazyLoad,
    AAuthModalLazyLoad,
    AFooter: hydrateWhenVisible(() =>
      import('@/components/_layout/AFooter/index.vue')
    ),
    GtmNoScript,
    ALayoutContentContainer,
    AErrorHandlerNotifier,
    WinnersHighlightsModalLazyLoad
  },
  mixins: [mixins.windowWidth, mixins.cmpEventsListener],
  head() {
    const cookieScriptTCFScript = {
      src: `https://geo.cookie-script.com/s/${this.$env.COOKIE_SCRIPT_TCF_2_BANNER_ID}.js?country=gb-br&region=eu`,
      type: 'text/javascript',
      charset: 'UTF-8',
      defer: true
    }

    const cookieScriptCCPAScript = {
      src: `https://geo.cookie-script.com/s/${this.$env.COOKIE_SCRIPT_CCPA_BANNER_ID}.js?state=${CMP_STATE.CA}`,
      type: 'text/javascript',
      charset: 'UTF-8',
      defer: true
    }

    const cookieScriptGlobalScript = {
      src: `https://cdn.cookie-script.com/s/${this.$env.COOKIE_SCRIPT_GLOBAL_BANNER_ID}.js`,
      type: 'text/javascript',
      charset: 'UTF-8',
      defer: true
    }

    // Note: order matters (Global should be last!)
    const cmpScripts = [
      cookieScriptTCFScript,
      cookieScriptCCPAScript,
      cookieScriptGlobalScript
    ]

    const gtmScript = {
      /** Google Tag Manager **/
      hid: 'gtm',
      innerHTML:
        '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(\n' +
        "    {'gtm.start': new Date().getTime(),event:'gtm.js'}\n" +
        '  );var f=d.getElementsByTagName(s)[0],\n' +
        "    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n" +
        "    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n" +
        `  })(window,document,'script','dataLayer','${this.$env.GTM_CONTAINER_ID}');`
    }

    return {
      script: [
        ...cmpScripts,
        ...(this.$env.GTM_CONTAINER_ID ? [gtmScript] : [])
      ],
      __dangerouslyDisableSanitizersByTagID: {
        gtm: ['innerHTML']
      }
    }
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    }
  }
}
</script>

<style lang="scss" scoped></style>
